export const readyEvent = {
  eventInfo: {
    eventAction: 'feature_app_ready',
    eventName: 'personalized content tiles - feature app ready',
  },
  attributes: {
    componentName: 'personalized-content-tiles',
    label: '',
    targetURL: '',
    clickID: '',
    elementName: '',
    value: '',
    pos: '',
  },
};
